import React from 'react';
import { Field } from '../../ui/Field';
import { TextInput } from '../../ui/TextControl';
import { ChoiceChip } from '../../ui/ChoiceChip';
import { asDraft } from '../../../types/registration';
import { PROGRAM_TYPES } from '../../../data/registration';
import type { QuestionProps } from './types';
export function ProgramsQuestion({
  data,
  update
}: QuestionProps) {
  const draft = asDraft(data);
  function toggleProgram(program: string) {
    const next = draft.programs.includes(program) ? draft.programs.filter(item => item !== program) : [...draft.programs, program];
    update({
      programs: next
    });
  }
  return <div className="flex flex-col gap-6" data-id="element-454" data-mp="20qumjtsm8nfn">
      <div className="flex flex-wrap gap-2" role="group" aria-label="What you were part of" data-id="element-455" data-mp="25riovbmaoqp6">
        {PROGRAM_TYPES.map(program => <ChoiceChip key={program} checked={draft.programs.includes(program)} onChange={() => toggleProgram(program)} data-id="element-456" data-mp="3c6jb2plipuik">
            {program}
          </ChoiceChip>)}
      </div>

      <Field name="roleNote" label="Anything an old friend would recognise you by" hint="Optional. A line is plenty." data-id="element-457" data-mp="1x8t6e6etrqfp">
        <TextInput id="roleNote" name="roleNote" placeholder="Tuesday night group, back room" value={draft.roleNote} onChange={event => update({
        roleNote: event.target.value
      })} data-id="element-458" data-mp="1o84upicwm25z" />
      </Field>
    </div>;
}